import i18n from 'locales/i18n';

export const booleanLabel =
  (labelKey: string) =>
  ({ value }: { value: unknown }) =>
    value !== undefined
      ? `${i18n.t(labelKey)}: ${
          value === true ? i18n.t('input.option.yes') : i18n.t('input.option.no')
        }`
      : null;
